import { useMutation } from '@tanstack/react-query'
import { logout as logoutRequest } from '@/services/api/auth'
import { useAuthStore } from '@/store/authStore'

const LOGOUT_MUTATION_KEY = ['mutation', 'auth', 'logout'] as const

/**
 * Revokes the server-side session (best-effort — network failure is
 * tolerated) then always clears local auth state via `authStore.logout()`.
 * Not offline-replayable — a queued logout would clear caches on replay
 * while the user is mid-session on another device/reload.
 */
export function useLogout() {
  const logout = useAuthStore((s) => s.logout)

  return useMutation({
    mutationKey: LOGOUT_MUTATION_KEY,
    mutationFn: async () => {
      try {
        await logoutRequest()
      } catch {
        // Ignore — clear local state regardless.
      }
    },
    onSettled: () => {
      logout()
    },
  })
}
